// Email validation
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateEmail = (email) => {
  if (!email || email.trim() === '') {
    return 'Email is required';
  }
  if (!isValidEmail(email)) {
    return 'Please enter a valid email address';
  }
  return '';
};

// Phone number validation
export const isValidPhoneNumber = (phoneNumber) => {
  const phoneRegex = /^\d{10,15}$/;
  return phoneRegex.test(phoneNumber);
};

export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return 'Phone number is required';
  }
  if (phoneNumber.length < 10) {
    return 'Phone number must be at least 10 digits';
  }
  if (!/^\d+$/.test(phoneNumber)) {
    return 'Phone number must contain only digits';
  }
  return '';
};

// Password validation
export const isValidPassword = (password) => {
  return password && password.length >= 8;
};

export const validatePassword = (password) => {
  if (!password || password.trim() === '') {
    return 'Password is required';
  }
  if (password.length < 8) {
    return 'Password must be at least 8 characters long';
  }
  return '';
};

export const validateConfirmPassword = (password, confirmPassword) => {
  if (!confirmPassword || confirmPassword.trim() === '') {
    return 'Please confirm your password';
  }
  if (password !== confirmPassword) {
    return 'Passwords do not match';
  }
  return '';
};

// Citizenship number validation (Nepal format)
export const isValidCitizenshipNumber = (number) => {
  return number && number.length > 0;
};

// Donation amount validation
export const isValidDonationAmount = (amount, min = 10, max = 25000) => {
  const numAmount = parseFloat(amount);
  return !isNaN(numAmount) && numAmount >= min && numAmount <= max;
};

// Date of Birth validation (minimum age 16 years)
export const validateDateOfBirth = (dob) => {
  if (!dob) {
    return 'Date of birth is required';
  }

  const birthDate = new Date(dob);
  const today = new Date();

  // Calculate age
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  // Adjust age if birthday hasn't occurred this year yet
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  if (age < 16) {
    return 'You must be at least 16 years old to register';
  }

  return '';
};

// Citizenship Issue Date validation (cannot be in the future)
export const validateCitizenshipIssueDate = (issueDate) => {
  if (!issueDate) {
    return 'Issue date is required';
  }

  const issueDateObj = new Date(issueDate);
  const today = new Date();

  // Set time to midnight for accurate date comparison
  today.setHours(0, 0, 0, 0);
  issueDateObj.setHours(0, 0, 0, 0);

  if (issueDateObj > today) {
    return 'Issue date cannot be in the future';
  }

  return '';
};

// Required field validation
export const isRequired = (value) => {
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  return value !== null && value !== undefined;
};

// Validate form errors
export const hasErrors = (errors) => {
  return Object.keys(errors).some(key => errors[key]);
};
